var lg_6711R1P070B_TV = {
    name: "6711R1P070B_TV",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,112,2,235,1,112,2,82,6,168,35,24,17,116,2,130,156,59,245,170,189,245,106,162],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,112,2,235,1,112,2,82,6,168,35,24,17,116,2,130,156,59,245,170,191,234,170,162],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,112,2,235,1,112,2,82,6,168,35,24,17,116,2,130,156,59,245,170,175,250,170,162],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,112,2,235,1,112,2,82,6,168,35,24,17,116,2,130,156,59,245,170,183,246,170,162],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,112,2,235,1,112,2,82,6,168,35,24,17,116,2,130,156,59,245,170,171,254,170,162],
        },
        {
            // function: "AV",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,112,2,235,1,112,2,82,6,168,35,24,17,116,2,130,156,59,245,170,171,127,106,162],
        },
    ]
}
export default lg_6711R1P070B_TV